import { SubmenuData } from '@professocial/professocialFormComponents/FormComponents/Submenu'
import i18n from 'i18next'

export const userDashboardSubmenu: SubmenuData[] = [
  {
    id: 'networkContent',
    label: i18n.t('coreDashboard:networkContent'),
  },
  {
    id: 'posting',
    label: i18n.t('coreDashboard:posting'),
  },
  {
    id: 'calendar',
    label: i18n.t('coreDashboard:calendar'),
  },
]

export const editorDashboardSubmenu: SubmenuData[] = [
  {
    id: 'networkContent',
    label: i18n.t('coreDashboard:networkContent'),
  },
  {
    id: 'takeTemplate',
    label: i18n.t('coreDashboard:takeTemplate'),
  },
  {
    id: 'posting',
    label: i18n.t('coreDashboard:posting'),
  },
  {
    id: 'calendar',
    label: i18n.t('coreDashboard:calendar'),
  },
]

export const settingsAppSubmenu: SubmenuData[] = [
  {
    id: 'userData',
    label: i18n.t('coreSettings:userData'),
  },
]

export const connectTab: SubmenuData = { id: 'connect', label: i18n.t('coreSettings:connect') }

export const EditorImagesSubnenu: SubmenuData[] = [
  {
    id: 'titleImages',
    label: i18n.t('coreImages:titleImages'),
  },
  {
    id: 'profileImages',
    label: i18n.t('coreImages:profileImages'),
  },
  {
    id: 'mediaGallery',
    label: i18n.t('coreImages:mediaGallery'),
  },
]

export const facebookSettingsSubmenu: SubmenuData[] = [
  {
    id: 'profileImage',
    label: i18n.t('facebookSettingsCommon:profileImage'),
  },
  {
    id: 'pageInfo',
    label: i18n.t('facebookSettingsCommon:pageInfo'),
  },
  {
    id: 'imprint',
    label: i18n.t('facebookSettingsCommon:imprint'),
  },
]
